import { render, staticRenderFns } from "./SingleCompany.vue?vue&type=template&id=14edc097&"
import script from "./SingleCompany.vue?vue&type=script&lang=js&"
export * from "./SingleCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports